import TermList from "../AdminTermList";

export default class AdminTermListServiceQuotePartStatus extends TermList {
  /**
   * @returns {string} The term type.
   */
  getType() {
    return "service_quote_part_status";
  }
}
